import { useMedia } from '@/hooks'
import { cn } from '@/lib/utils'
import { useStoreI18n } from '@/store'
import { Typo3ReportsWinterhike } from '@/types'
import { StatusChip } from '@/ui/components'
import { MEDIA } from '@spot'
import { memo } from 'react'
import MapFrame from '../../../MapFrame'

interface Props extends Typo3ReportsWinterhike {
  isLayoutWinter: boolean
}

const AccordionBody = ({ isLayoutWinter, ...data }: Props) => {
  const D = useStoreI18n.use.dictionary()
  const isDesktop = useMedia(MEDIA.desktop, true)

  return (
    <div className={''}>
      {data?.mapLink && isLayoutWinter && isDesktop && (
        <MapFrame src={data?.mapLink} />
      )}
      {data?.listTrails?.map((item, i) => (
        <div className={''} key={i?.toString()}>
          <div className={''}>
            <p className="text-large font-weight-700">{item?.title}</p>
          </div>
          <div className={cn('')}>{item?.designationLabel}</div>
          <div className={''}>
            <div className={''}>
              <p className="text-small text-neutral-400">
                {D['fe.winterHike.km']}
              </p>
              <div className={''}>
                <p>
                  <span
                    className={cn(
                      'text-large',
                      'font-weight-700',
                      data.status === 'CLOSED'
                        ? 'text-feedback-red'
                        : 'text-feedback-green'
                    )}
                  >
                    {item.lengthKm}
                  </span>
                  &nbsp;km
                </p>
              </div>
            </div>
            <div className={''}>
              {item?.condition !== 'NO_INFO' ? (
                <>
                  <p className="text-small text-neutral-400">
                    {D['fe.winterHike.condition']}
                  </p>
                  <p>{item?.conditionLabel}</p>
                </>
              ) : null}
            </div>
            <div className={cn('', '')}>
              <p className="text-small text-neutral-400">
                {D['fe.winterHike.status']}
              </p>
              <StatusChip
                status={item.status === 'OPEN' ? 'success' : 'error'}
              />
            </div>
          </div>
        </div>
      ))}
    </div>
  )
}

export default memo(AccordionBody)
